import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { get, isEmpty, isEqual, isUndefined, isNull } from 'lodash';
import { FormattedMessage } from 'react-intl';
import qs from 'qs';
import asyncRoute from '../../../../../helpers/hoc/asyncRoute';
import rewardsRoutes from '../../../../../routes/rewards';
import {
  fetchDealByIdAction,
  clearBrandDealDataAction,
  fetchRewardGuestDetailsAction,
  fetchRewardPointsAction,
} from '../../../../../actions/rewards';
import {
  clearSubscribedGuestDealAction,
  fetchSubscribedGuestDealAction,
  subscribeDealAction,
} from '../../../../../actions/app.action';
import resourcesConfig from '../../../../../resources';
import { apiResponseCodes } from '../../../../../constants/globals';
import { constants } from '../../../../../constants/configuration';
import {
  birthdayRewardAvailableDate,
  anniversaryRewardAvailableDate,
} from '../../../../Rewards/helpers';
import {
  birthdayRewardPreMonths,
  rewardCategory,
  anniversaryrewardPreMonths,
} from '../../../../Rewards/config';
import CouponCardSkeleton from '../../../../Rewards/components/Skeleton/CouponCardSkeleton';
import LocationCardSkeleton from '../../../../Rewards/components/Skeleton/LocationCardSkeleton';
import SadEmojiIcon from '../../../../../assets/images/sad-emoji.png';

import './CampaignDetail.scss';

const RewardCard = asyncRoute(() => import('../../../../Rewards/components/Card/RewardCard'));
const CouponTnC = asyncRoute(() => import('../../../../../components/CouponTnC'));
const HowToReedem = asyncRoute(() => import('../../../../Rewards/components/HowToReedem'));
const RedemptionDetails = asyncRoute(() =>
  import('../../../../../components/Popup/RedemptionDetails'),
);
const SlideAnimation = asyncRoute(() => import('../../../../Rewards/components/SlideAnimation'));
const CampaignReward = asyncRoute(() => import('../../CampaignReward'));
const Button = asyncRoute(() => import('../../../../../components/MaterialElements/Button'));

const CampaignDetail = ({
  actions,
  location,
  history,
  weekdays,
  rewardPoints,
  guestId,
  guestDetails,
  brandGuestId,
  brandId,
  rewardProgram,
  socialMediaCampaignDetails,
  themeData,
}) => {
  const dob = get(guestDetails, 'dob', '');
  const doa = get(guestDetails, 'doa', '');
  const birthdayDealStartDate =
    dob && birthdayRewardAvailableDate(dob, birthdayRewardPreMonths, 'claim').startDate;
  const birthdayDealEndDate = dob && birthdayRewardAvailableDate(dob).endDate;
  const anniversaryDealStartDate =
    doa && anniversaryRewardAvailableDate(doa, anniversaryrewardPreMonths, 'claim').startDate;
  const anniversaryDealEndDate = doa && anniversaryRewardAvailableDate(doa).endDate;
  const [deal, setDeal] = useState({});
  const [animationType, setAnimationType] = useState();
  const [rewardClaimed, setRewardClaimed] = useState(false);
  const [initialAPIInteractionDone, setInitialAPIInteractionDone] = useState(false);
  const [fallbackDeal, setFallbackDeal] = useState({});
  const [showNoAvailableOfferSection, setShowNoAvailableOfferSection] = useState(false);
  const [showRedeemOrExpiredSection, setShowRedeemOrExpiredSection] = useState(false);

  const queryParams = qs.parse(location.search, { ignoreQueryPrefix: true });
  const isExistingUser = get(queryParams, 'isExistingUser', '') === 'true';

  useEffect(() => {
    setAnimationType(get(location, 'state.animationType', 'fadeInOut'));

    return () => {
      actions.clearBrandDealData();
      actions.clearSubscribedDeal();
    };
  }, []);

  useEffect(() => {
    const campaignPlan = get(socialMediaCampaignDetails, 'campaignPlan', {});
    const dealCode = get(campaignPlan, 'rules.campaignDeals', []).find(() => true);
    const fetchDealData = async () => {
      try {
        const existingUserContext = get(campaignPlan, 'existingUser', {});

        const existingUserOffer = getOfferForExistingUser({
          existingUserContext,
        });
        const campaignDealResponse = await actions.fetchDealById({ dealCode, guestId });
        if (apiResponseCodes.SUCCESS.includes(get(campaignDealResponse, 'status', ''))) {
          const guestCoupons = get(campaignDealResponse, 'data.guestCoupons', []);
          const guestCoupon = guestCoupons.find((gCoupon) => gCoupon) || {};
          const activeDealGuests = get(guestCoupon, 'activeDealGuests.0', {});
          const redeemedDealGuest = get(guestCoupon, 'redeemedDealGuests.0', {});
          const expiredDealGuest = get(guestCoupon, 'expiredDealGuests.0', {});
          const perGuestMax = get(campaignDealResponse, 'data.perGuestMax');

          if (!isEmpty(activeDealGuests)) {
            setDeal(activeDealGuests);
            setShowRedeemOrExpiredSection(false);
          } else if (!isEmpty(redeemedDealGuest)) {
            setDeal(redeemedDealGuest);
            setShowRedeemOrExpiredSection(true);
          } else if (!isEmpty(expiredDealGuest)) {
            setDeal(expiredDealGuest);
            setShowRedeemOrExpiredSection(true);
          } else {
            if (isEmpty(existingUserOffer)) {
              // check if perGuestMax > 1 or undefied then user can subscribe the coupon again
              if (
                isNull(perGuestMax) ||
                isUndefined(perGuestMax) ||
                perGuestMax > redeemedDealGuest.length
              ) {
                setDeal(campaignDealResponse.data);
                handleDealCTAClick(get(campaignDealResponse, 'data.id'));
              }
            } else {
              const hasAlternateOffer = get(existingUserOffer, 'hasAlternateOffer');
              if (!hasAlternateOffer) {
                setShowNoAvailableOfferSection(true);
              } else {
                const fallbackDealCode = get(existingUserOffer, 'fallbackDeals', []).find(
                  () => true,
                );
                const response = await actions.fetchDealById({
                  dealCode: fallbackDealCode,
                  guestId,
                });
                if (apiResponseCodes.SUCCESS.includes(get(response, 'status', ''))) {
                  const fallbackDealGuestCoupons = get(response, 'data.guestCoupons', []);
                  const fallbackDealGuestCoupon =
                    fallbackDealGuestCoupons.find((gCoupon) => gCoupon) || {};
                  const falbackDealActiveDealGuests = get(
                    fallbackDealGuestCoupon,
                    'activeDealGuests.0',
                    {},
                  );
                  const falbackDealRedeemedDealGuest = get(
                    fallbackDealGuestCoupon,
                    'redeemedDealGuests.0',
                    {},
                  );
                  const falbackDealExpiredDealGuest = get(
                    fallbackDealGuestCoupon,
                    'expiredDealGuests.0',
                    {},
                  );
                  if (!isEmpty(falbackDealActiveDealGuests)) {
                    setDeal(get(campaignDealResponse, 'data', {}));
                    setFallbackDeal(falbackDealActiveDealGuests);
                    setShowRedeemOrExpiredSection(false);
                  } else if (!isEmpty(falbackDealRedeemedDealGuest)) {
                    setDeal(falbackDealRedeemedDealGuest);
                    setShowRedeemOrExpiredSection(true);
                  } else if (!isEmpty(falbackDealExpiredDealGuest)) {
                    setDeal(falbackDealExpiredDealGuest);
                    setShowRedeemOrExpiredSection(true);
                  } else {
                    setDeal(get(campaignDealResponse, 'data', {}));
                    handleDealCTAClick(get(response, 'data.id'));
                  }
                }
              }
            }
          }
        }
        setInitialAPIInteractionDone(true);
      } catch (error) {
        console.error('Error fetching deal data:', error);
      }
    };
    if (!isEmpty(dealCode)) {
      fetchDealData();
    }
  }, [socialMediaCampaignDetails]);

  useEffect(() => {
    if (isEmpty(rewardPoints)) {
      if (!isEmpty(brandId) && !isEmpty(brandGuestId)) {
        actions.fetchRewardPoints({
          url: `/aggregateRecords/guests?brandId=${brandId}&entityType=BRAND_GUEST&entityId=${brandGuestId}&recordTypes=REWARD_POINT&frequencyTypes=ALL_TIME`,
        });
      }
    }
  }, [brandGuestId]);

  const getOfferForExistingUser = ({ existingUserContext }) => {
    // Check if existingUserContext object exists
    if (existingUserContext) {
      const { hasAlternateOffer } = existingUserContext;

      if (isExistingUser && hasAlternateOffer) {
        return existingUserContext;
      }
    }
  };

  const checkCouponStatus = (coupon) => {
    if (!isEmpty(get(coupon, 'redeemTime', ''))) {
      return constants.couponDetail.couponStatus.redeemed;
    } else if (get(coupon, 'isExpired', '') === true) {
      return constants.couponDetail.couponStatus.expired;
    } else if (get(coupon, 'subscribeTime', '')) {
      return constants.couponDetail.couponStatus.subscribed;
    } else {
      return false;
    }
  };

  const handleDealCTAClick = (dealId) => {
    const dealCategory = get(deal, 'category', '');
    const guestCoupons = get(deal, 'guestCoupons', []);
    const perGuestMax = get(deal, 'perGuestMax');
    const guestCoupon = (guestCoupons.length > 0 && guestCoupons.find((gCoupon) => gCoupon)) || {};
    const redeemedDealGuest = get(guestCoupon, 'redeemedDealGuests', []);
    const subscribeDealReqBody = {
      dealId,
      dealGuest: {
        guestId,
        brandGuestId,
      },
    };
    const withLoader = false;
    if (dealCategory === rewardCategory.reward) {
      actions.subscribeDeal({ subscribeDealReqBody }, withLoader).then((response) => {
        if (apiResponseCodes.SUCCESS.includes(get(response, 'status'))) {
          if (isExistingUser) {
            setRewardClaimed(true);
            setFallbackDeal(get(response, 'data.dealGuest'));
          } else {
            setRewardClaimed(true);
            setDeal(get(response, 'data.dealGuest'));
          }
        }
      });
    } else {
      if (
        isNull(perGuestMax) ||
        isUndefined(perGuestMax) ||
        perGuestMax > redeemedDealGuest.length
      ) {
        actions.subscribeDeal({ subscribeDealReqBody }).then((response) => {
          if (apiResponseCodes.SUCCESS.includes(get(response, 'status'))) {
            if (isExistingUser) {
              setRewardClaimed(true);
              setFallbackDeal(get(response, 'data.dealGuest'));
            } else {
              setRewardClaimed(true);
              setDeal(get(response, 'data.dealGuest'));
            }
          }
        });
      }
    }
  };

  const handleGoBackClick = () => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.set('view', 'pre-signin'); // Set 'view' parameter
    searchParams.delete('isExistingUser'); // Delete 'isExistingUser' parameter
    history.replace({
      pathname: location.pathname,
      search: searchParams.toString(),
    });
  };

  const couponStatus = checkCouponStatus(deal);
  const showTnc =
    ![
      constants.couponDetail.couponStatus.expired,
      constants.couponDetail.couponStatus.redeemed,
    ].includes(couponStatus) && !showNoAvailableOfferSection;

  const celebrationBannerUrl = get(
    socialMediaCampaignDetails,
    'campaignPlan.additionalData.celebrationBannerUrl',
    '',
  );

  return (
    <SlideAnimation animationType={animationType}>
      <div className="campaign-detail-v2">
        <CouponCardSkeleton
          isLoading={!initialAPIInteractionDone}
          variant="swipe"
          numberOfElements={1}
        >
          {!showNoAvailableOfferSection && (
            <>
              {!showRedeemOrExpiredSection ? (
                <>
                  <CampaignReward
                    themeData={themeData}
                    deal={deal}
                    fallbackDeal={fallbackDeal}
                    celebrationBannerUrl={celebrationBannerUrl}
                    rewardClaimed={rewardClaimed}
                    isExistingUser={isExistingUser}
                  />
                  <div className="campaign-detail-v2_section-break" />
                </>
              ) : (
                <RewardCard
                  currencyName={get(rewardProgram, 'currencyName', resourcesConfig.rewardPoints)}
                  rewardPoints={rewardPoints}
                  deal={deal}
                  dob={dob}
                  doa={doa}
                  birthdayDealStartDate={birthdayDealStartDate}
                  birthdayDealEndDate={birthdayDealEndDate}
                  anniversaryDealStartDate={anniversaryDealStartDate}
                  anniversaryDealEndDate={anniversaryDealEndDate}
                  history={history}
                  rewardClaimed={rewardClaimed}
                />
              )}
            </>
          )}
          {showNoAvailableOfferSection && (
            <div className="campaign-detail-v2_no-offer-available">
              <div className="campaign-detail-v2_no-offer-available_emoji">
                <img src={SadEmojiIcon} alt="no-offer-available" />
              </div>
              <div className="campaign-detail-v2_no-offer-available_title">
                <FormattedMessage
                  id="noOfferApplicableTitle"
                  defaultMessage={resourcesConfig.noOfferApplicableTitle}
                />
              </div>
              <div className="campaign-detail-v2_no-offer-available_description">
                <FormattedMessage
                  id="noOfferApplicableDescription"
                  defaultMessage={resourcesConfig.noOfferApplicableDescription}
                />
              </div>
              <div className="campaign-detail-v2_no-offer-available_CTA">
                <Button
                  content={
                    <FormattedMessage id="goBackCTA" defaultMessage={resourcesConfig.goBackCTA} />
                  }
                  themeContext={rewardsRoutes.rewards}
                  onClick={() => handleGoBackClick()}
                />
              </div>
            </div>
          )}
        </CouponCardSkeleton>

        {!initialAPIInteractionDone ? (
          <>
            <LocationCardSkeleton isLoading={!initialAPIInteractionDone} lines="4" />
            <div className="campaign-detail-v2_section-break" />
            <LocationCardSkeleton isLoading={!initialAPIInteractionDone} lines="4" />
            <div className="campaign-detail-v2_section-break" />
            <LocationCardSkeleton isLoading={!initialAPIInteractionDone} lines="4" />
          </>
        ) : (
          showTnc && (
            <>
              <HowToReedem
                applicableOn={get(deal, 'applicableOn', 'ALL')}
                view={get(deal, 'category')}
                deal={deal}
              />
              <div className="campaign-detail-v2_section-break" />
              <CouponTnC deal={deal} weekdays={weekdays} dob={dob} doa={doa} />
            </>
          )
        )}
        {isEqual(couponStatus, constants.couponDetail.couponStatus.redeemed) && (
          <RedemptionDetails subscribedDeal={deal} />
        )}
      </div>
    </SlideAnimation>
  );
};

const mapStateToProps = (state) => ({
  brandId: get(state, 'common.appStartupInfo.brandId', ''),
  rewardProgram: get(state, 'common.appStartupInfo.rewardProgram', {}),
  weekdays: get(state, 'app.masterData.weekdays', []),
  rewardPoints: get(state, 'rewards.rewardPoints._embedded.guestAggregateRecords.0.value', 0),
  guestId: get(state, 'rewards.rewardGuestDetails.guestId', ''),
  brandGuestId: get(state, 'rewards.rewardGuestDetails.id', ''),
  guestDetails: get(state, 'rewards.rewardGuestDetails', {}),
  resources: get(state, 'common.resources', {}),
  socialMediaCampaignDetails: get(state, 'common.socialMediaCampaignDetails', {}),
  themeData: get(state, 'common.resources.themeData', {}),
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      fetchDealById: fetchDealByIdAction,
      clearBrandDealData: clearBrandDealDataAction,
      subscribeDeal: subscribeDealAction,
      fetchSubscribedGuestDeal: fetchSubscribedGuestDealAction,
      fetchRewardGuestDetails: fetchRewardGuestDetailsAction,
      fetchRewardPoints: fetchRewardPointsAction,
      clearSubscribedDeal: clearSubscribedGuestDealAction,
    },
    dispatch,
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(CampaignDetail);
